import { jsx as _jsx } from "react/jsx-runtime";
import * as heroIconsSolid from '@heroicons/react/solid';
var isImageSource = function (icon) {
    return !!icon && (icon.startsWith('data:image/') || /[/.]/.test(icon));
};
var renderIcon = function (iconName, className, iconType) {
    if (className === void 0) { className = ''; }
    if (iconType === 'img') {
        return _jsx("img", { src: iconName, alt: "", className: className });
    }
    var SelectedIcon = heroIconsSolid[iconName];
    return _jsx(SelectedIcon, { className: className });
};
export { isImageSource, renderIcon };
//# sourceMappingURL=icon-utils.js.map